// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Controls_controlsContainer__K0WzL {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 12px;
  background-color: #f7fafc;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  flex-direction: column;
}

.Controls_controlGroup__hCukT {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.Controls_controlLabel__PqVo2 {
  font-size: 13px;
  font-weight: 500;
  color: #4a5568;
  margin-right: 4px;
}

.Controls_controlButton__eVeYw {
  padding: 4px 12px;
  background-color: white;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 12px;
  color: #4a5568;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.Controls_controlButton__eVeYw:hover:not(.Controls_activeControl__ww1Ka) {
  background-color: #edf2f7;
}

/* Active state for both vertical and horizontal */
.Controls_activeControl__ww1Ka {
  background-color: #4299e1;
  color: white;
  border-color: #4299e1;
}

/* Specific styles for vertical active state (optional - can use same as activeControl) */
.Controls_activeControlVertical__eXQnN {
  background-color: #4299e1;
  color: white;
  border-color: #4299e1;
  box-shadow: 0 2px 4px rgba(66, 153, 225, 0.3);
}

/* Specific styles for horizontal active state (optional - can use same as activeControl) */
.Controls_activeControlHorizontal__Z7een {
  background-color: #48bb78;
  color: white;
  border-color: #48bb78;
  box-shadow: 0 2px 4px rgba(72, 187, 120, 0.3);
}

/* Alternative: Use different colors for vertical vs horizontal */
.Controls_activeControl__ww1Ka.Controls_vertical__nUVoj {
  background-color: #4299e1;
  color: white;
  border-color: #4299e1;
}

.Controls_activeControl__ww1Ka.Controls_horizontal__E6Vsx {
  background-color: #48bb78;
  color: white;
  border-color: #48bb78;
}

/* Badge/indicator for current layout direction */
.Controls_directionIndicator__PacVl {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  margin-left: 8px;
}

.Controls_directionIndicator__PacVl.Controls_vertical__nUVoj {
  background-color: #ebf8ff;
  color: #2b6cb0;
}

.Controls_directionIndicator__PacVl.Controls_horizontal__E6Vsx {
  background-color: #f0fff4;
  color: #276749;
}

/* Icon for direction indicator */
.Controls_directionIndicator__PacVl .Controls_icon__DRT2S {
  font-size: 14px;
}

/* Layout direction preview styles */
.Controls_layoutVertical__qalYC {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Controls_layoutHorizontal__fDezc {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
}

/* Array items container based on direction */
.Controls_arrayContainerVertical__js16u {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.Controls_arrayContainerHorizontal__swNRX {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
}

.Controls_arrayContainerHorizontal__swNRX .Controls_itemCard__Ct1bR {
  flex: 1 1 200px;
  min-width: 150px;
  max-width: 300px;
}

/* Preview container styles based on direction */
.Controls_previewVertical__r2gqi {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
}

.Controls_previewHorizontal__9Rih7 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  padding: 12px;
  overflow-x: auto;
}

.Controls_previewHorizontal__9Rih7 .Controls_previewItem__n388E {
  flex: 0 0 auto;
  min-width: 250px;
  max-width: 350px;
}

/* Responsive: On smaller screens, horizontal becomes vertical */
@media (max-width: 768px) {
  .Controls_previewHorizontal__9Rih7 {
    flex-direction: column;
  }
  
  .Controls_previewHorizontal__9Rih7 .Controls_previewItem__n388E {
    flex: 1 1 auto;
    max-width: 100%;
  }
  
  .Controls_arrayContainerHorizontal__swNRX {
    flex-direction: column;
  }
  
  .Controls_arrayContainerHorizontal__swNRX .Controls_itemCard__Ct1bR {
    flex: 1 1 auto;
    max-width: 100%;
  }
}

/* Animation for direction change */
.Controls_arrayContainerVertical__js16u,
.Controls_arrayContainerHorizontal__swNRX,
.Controls_previewVertical__r2gqi,
.Controls_previewHorizontal__9Rih7 {
  transition: all 0.3s ease;
}

/* Tooltip styles for direction buttons */
.Controls_controlButton__eVeYw[data-direction="vertical"]:hover::after,
.Controls_controlButton__eVeYw[data-direction="horizontal"]:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 4px 8px;
  background-color: #2d3748;
  color: white;
  font-size: 10px;
  border-radius: 4px;
  white-space: nowrap;
  margin-bottom: 4px;
}

.Controls_controlButton__eVeYw {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/PreviewTesterHome/PreviewEditorHome/Controls.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,yFAAyF;AACzF;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,2FAA2F;AAC3F;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,iEAAiE;AACjE;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;;;;EAIE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".controlsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding: 12px;\n  background-color: #f7fafc;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  flex-direction: column;\n}\n\n.controlGroup {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.controlLabel {\n  font-size: 13px;\n  font-weight: 500;\n  color: #4a5568;\n  margin-right: 4px;\n}\n\n.controlButton {\n  padding: 4px 12px;\n  background-color: white;\n  border: 1px solid #d0d0d0;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #4a5568;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.controlButton:hover:not(.activeControl) {\n  background-color: #edf2f7;\n}\n\n/* Active state for both vertical and horizontal */\n.activeControl {\n  background-color: #4299e1;\n  color: white;\n  border-color: #4299e1;\n}\n\n/* Specific styles for vertical active state (optional - can use same as activeControl) */\n.activeControlVertical {\n  background-color: #4299e1;\n  color: white;\n  border-color: #4299e1;\n  box-shadow: 0 2px 4px rgba(66, 153, 225, 0.3);\n}\n\n/* Specific styles for horizontal active state (optional - can use same as activeControl) */\n.activeControlHorizontal {\n  background-color: #48bb78;\n  color: white;\n  border-color: #48bb78;\n  box-shadow: 0 2px 4px rgba(72, 187, 120, 0.3);\n}\n\n/* Alternative: Use different colors for vertical vs horizontal */\n.activeControl.vertical {\n  background-color: #4299e1;\n  color: white;\n  border-color: #4299e1;\n}\n\n.activeControl.horizontal {\n  background-color: #48bb78;\n  color: white;\n  border-color: #48bb78;\n}\n\n/* Badge/indicator for current layout direction */\n.directionIndicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n  margin-left: 8px;\n}\n\n.directionIndicator.vertical {\n  background-color: #ebf8ff;\n  color: #2b6cb0;\n}\n\n.directionIndicator.horizontal {\n  background-color: #f0fff4;\n  color: #276749;\n}\n\n/* Icon for direction indicator */\n.directionIndicator .icon {\n  font-size: 14px;\n}\n\n/* Layout direction preview styles */\n.layoutVertical {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.layoutHorizontal {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n/* Array items container based on direction */\n.arrayContainerVertical {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.arrayContainerHorizontal {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.arrayContainerHorizontal .itemCard {\n  flex: 1 1 200px;\n  min-width: 150px;\n  max-width: 300px;\n}\n\n/* Preview container styles based on direction */\n.previewVertical {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n}\n\n.previewHorizontal {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding: 12px;\n  overflow-x: auto;\n}\n\n.previewHorizontal .previewItem {\n  flex: 0 0 auto;\n  min-width: 250px;\n  max-width: 350px;\n}\n\n/* Responsive: On smaller screens, horizontal becomes vertical */\n@media (max-width: 768px) {\n  .previewHorizontal {\n    flex-direction: column;\n  }\n  \n  .previewHorizontal .previewItem {\n    flex: 1 1 auto;\n    max-width: 100%;\n  }\n  \n  .arrayContainerHorizontal {\n    flex-direction: column;\n  }\n  \n  .arrayContainerHorizontal .itemCard {\n    flex: 1 1 auto;\n    max-width: 100%;\n  }\n}\n\n/* Animation for direction change */\n.arrayContainerVertical,\n.arrayContainerHorizontal,\n.previewVertical,\n.previewHorizontal {\n  transition: all 0.3s ease;\n}\n\n/* Tooltip styles for direction buttons */\n.controlButton[data-direction=\"vertical\"]:hover::after,\n.controlButton[data-direction=\"horizontal\"]:hover::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 4px 8px;\n  background-color: #2d3748;\n  color: white;\n  font-size: 10px;\n  border-radius: 4px;\n  white-space: nowrap;\n  margin-bottom: 4px;\n}\n\n.controlButton {\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controlsContainer": `Controls_controlsContainer__K0WzL`,
	"controlGroup": `Controls_controlGroup__hCukT`,
	"controlLabel": `Controls_controlLabel__PqVo2`,
	"controlButton": `Controls_controlButton__eVeYw`,
	"activeControl": `Controls_activeControl__ww1Ka`,
	"activeControlVertical": `Controls_activeControlVertical__eXQnN`,
	"activeControlHorizontal": `Controls_activeControlHorizontal__Z7een`,
	"vertical": `Controls_vertical__nUVoj`,
	"horizontal": `Controls_horizontal__E6Vsx`,
	"directionIndicator": `Controls_directionIndicator__PacVl`,
	"icon": `Controls_icon__DRT2S`,
	"layoutVertical": `Controls_layoutVertical__qalYC`,
	"layoutHorizontal": `Controls_layoutHorizontal__fDezc`,
	"arrayContainerVertical": `Controls_arrayContainerVertical__js16u`,
	"arrayContainerHorizontal": `Controls_arrayContainerHorizontal__swNRX`,
	"itemCard": `Controls_itemCard__Ct1bR`,
	"previewVertical": `Controls_previewVertical__r2gqi`,
	"previewHorizontal": `Controls_previewHorizontal__9Rih7`,
	"previewItem": `Controls_previewItem__n388E`
};
export default ___CSS_LOADER_EXPORT___;
